module.exports = __webpack_public_path__ + "static/media/wepik-export-20230616003121mpHF.ec085ca6.png";